import { Route } from '@angular/router';
import { TagsComponent } from '../../../../../pages/datasets/tags/tags.component';
import { TagEditComponent } from '../../../../../pages/datasets/tag-edit/tag-edit.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const tags: Route = {
  path: 'tags',
  title: 'nav.datasets.tags',
  data: {
    breadcrumb: 'nav.datasets.tags',
    icon: SbIcons.tags,
    id: RoutingID.tags,
  },
  children: [
    {
      path: '',
      component: TagsComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'tag-details/:tagID',
      title: 'nav.datasets.tag.details',
      data: {
        breadcrumb: 'nav.datasets.tag.details',
        icon: SbIcons.details,
        id: RoutingID.tagDetails,
      },
      children: [
        {
          path: '',
          component: TagsComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'tag-edit/:tagID',
      title: 'nav.datasets.tag.edit',
      data: {
        breadcrumb: 'nav.datasets.tag.edit',
        icon: SbIcons.edit,
        id: RoutingID.tagEdit,
      },
      children: [
        {
          path: '',
          component: TagEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'tag-create',
      title: 'nav.datasets.tag.create',
      data: {
        breadcrumb: 'nav.datasets.tag.create',
        icon: SbIcons.plus,
        id: RoutingID.tagCreate,
      },
      children: [
        {
          path: '',
          component: TagEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
